<template>
  <div class="RadioGroup">
    <div class="label"></div>

    <div class="items text-items">
      <template v-for="(item, i) in items">
        <radio
          v-autofocus="i === 0 && shouldFocus"
          :key="item.value"
          v-model="model"
          :name="radioName"
          :disabled="item.disabled"
          :input-value="item.value"
          class="radio"
          @input="select(item.value)"
        >
          <span v-html="item.text" />
        </radio>
      </template>
    </div>
  </div>
</template>

<script>
import Radio from './Radio'
import focusDirective from '../../directives/focus'

export default {
  name: 'RadioGroup',

  components: {
    Radio,
  },

  directives: {
    autofocus: focusDirective,
  },

  props: {
    value: {
      type: [Object, String, Number, Boolean],
      default: '',
    },

    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      model: this.value,
      originalModel: this.value,
      isMobile: /Android|Mobi|iPad|iPhone/.test(navigator.userAgent),
    }
  },

  computed: {
    radioName() {
      return this.name || 'radio' + this._uid
    },

    /**
     * autofocus is disabled completely on mobile!
     * @return {Boolean}
     */
    shouldFocus() {
      return this.autofocus && !this.isMobile
    },
  },

  watch: {
    value(val) {
      if (!this.originalModel) {
        this.originalModel = val
      }
      this.model = val
    },
  },

  methods: {
    select(value, isDisabled = false) {
      if (isDisabled === false) {
        this.model = value
        this.$emit('input', value)
      }
    },

    isOriginal(item) {
      return item.value === this.originalModel
    },
  },
}
</script>

<style lang="postcss" scoped>
.RadioGroup {
  font-family: 'Open Sans', sans-serif;
  margin-bottom: 20px;
  display: inline-block;

  .label {
    position: relative;
  }

  .items {
    display: flex;
    flex-direction: column;
  }

  .text-items {
    .radio {
      padding-bottom: 10px;

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
}
</style>
